import { createContext, useContext } from 'react';
import { Variable, VisibilityDependencyRule } from './types';
import { ParsedEntryValue } from './utils/formUtils';

export type FieldEntry = {
	from: ParsedEntryValue;
	to: ParsedEntryValue;
	variable: Variable;
	becauseRules: VisibilityDependencyRule[];
};
export type Fields = Map<string, FieldEntry>;

export type TAutoClearedFieldsContext = {
	fields: Fields;
	setField: (key: string, value: FieldEntry) => void;
	deleteField: (key: string) => void;
};

export const AutoClearedFieldsContext = createContext<TAutoClearedFieldsContext | null>({
	fields: new Map(),
	setField: () => {
		/* empty */
	},
	deleteField: () => {
		/* empty */
	}
});

export const useAutoClearedFields = () => {
	const context = useContext(AutoClearedFieldsContext);
	if (!context)
		throw new Error(
			'useAutoClearedFields needs to be used in context of AutoClearedFieldsContext'
		);

	return context.fields;
};

export const useSetAutoClearedFields = () => {
	const context = useContext(AutoClearedFieldsContext);
	if (!context)
		throw new Error(
			'useSetAutoClearedFields needs to be used in context of AutoClearedFieldsContext'
		);

	const { setField, deleteField } = context;
	return { setField, deleteField };
};
